import React, { useContext, useState, useCallback } from 'react';
import CollectACHDetailsFormEmbeddable, {
  initialState as initialACHState,
} from '../../library/CollectACHDetailsFormEmbeddable';
import { StateContext } from '../../../state';
import Title from '../../library/Title';
import ConfigComponent from '../../ConfigComponent';
import { actions } from '../../../state/actions';
import StartOver from '../../library/StartOver';
import { get } from 'lodash/object';
import MuiButton from '../../library/MuiButton';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

// Styles
const useStyles = makeStyles((theme) => ({
  input: {
    width: 300,
    '& + &': {
      marginTop: 20,
    },
  },
  disabled: {
    pointerEvents: 'none',
    background: '#ECECEC',
  },
  submit: {
    width: 150,
    height: 45,
    marginTop: 10,
  },
}));

export function CollectACHDetailsView({ onSubmit, isFetching }) {
  const [
    {
      configuration: {
        recipientLogin: { title, description, startOverLink },
      },
    },
    dispatch,
  ] = useContext(StateContext);

  const classes = useStyles();

  const [formValues, setFormValues] = useState({
    ach: initialACHState,
  });

  // validation states
  const [isACHValid, setIsACHValid] = useState(false);

  // handle ACH changes from child component
  const handleACHChange = useCallback((newACHValues) => {
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      ach: {
        ...prevFormValues.ach,
        ...newACHValues,
      },
    }));
  }, []);

  // handle ACH validation changes from child component
  const handleACHValidation = useCallback((isValid) => {
    setIsACHValid(isValid);
  }, []);
  
  // caching form values in session storage to allow user to return to form to perform edits
  const enableBrowserCache = true;

  // determine if entire form is valid
  const isFormValid = isACHValid;

  return (
    <>
      <Title>
        <h1>
          <ConfigComponent config={title} />
        </h1>
      </Title>
      <section>
        <p style={{ textAlign: 'center', padding: '1em 0 0 0' }}>
          <ConfigComponent
            config={description}
            actions={{ startOver: () => dispatch(actions.startOver()) }}
          />
        </p>
      </section>
      <section className="main">
        <CollectACHDetailsFormEmbeddable
          onChange={handleACHChange}
          onValidationChange={handleACHValidation}
          enableBrowserCache={enableBrowserCache}
        />
      </section>
      <section style={{ padding: '1.5em 0' }}>
        <MuiButton
          className={clsx(classes.input, classes.submit, {
            [classes.disabled]: !isFormValid,
          })}
          type="submit"
          variant="contained"
          color="primary"
          size="large"
          isFetching={isFetching}
          disabled={!isFormValid}
          onClick={() => {
            onSubmit(formValues);
          }}
        >
          Submit
        </MuiButton>
      </section>
      {get(startOverLink, 'show') && (
        <section>
          <StartOver {...get(startOverLink, 'props', {})} />
        </section>
      )}
    </>
  );
}

export default CollectACHDetailsView;
